import { CodiceServizioSerivizioPianoEccellenza } from '../servizi/servizi';

export const CampagnaPianiValore = 'https://www.cgn.it/piani-di-valore/?utm_source=assistentecgn&utm_medium=funzioneDossier730&utm_campaign=piani-di-valore-2024';

// eslint-disable-next-line max-len
export const ConfermaEccellenza = '#/pianidivalore?utm_source=sitocgn_piattaforma&utm_medium=drawerassistenteintegratoDossier730&utm_campaign=piani-di-valore-2024';

const scandenzaCampagnaPianoEccellenza = new Date(2025, 0, 31, 23, 59, 59, 999);

export function getDescrizioneDataScadenza() {
  return 'il 31 Gennaio 2025';
}

export function isCampagnaPianoEccellenzaConclusa() {
  if (new Date().getTime() > scandenzaCampagnaPianoEccellenza.getTime()) {
    return true;
  }

  return false;
}

export function isServizioEccellenzaAttivo(servizi) {
  return servizi.some((x) => x.Alias === CodiceServizioSerivizioPianoEccellenza);
}

export function getConfermaEccellenzaUrl() {
  return window.UrlMyContratti + ConfermaEccellenza;
}
